import { createGlobalStyle } from 'styled-components';

/**
 * Ability to prevent iframes (external embeds) from capturing move event while dragging. Otherwise,
 * the currently dragged element becomes "stuck" and stops moving until user hovers parent document again
 * A similar technique is implemented in useDragResize
 */
export const DraggingGlobalStyle = createGlobalStyle<{ $isDragging?: boolean }>`
  iframe {
    ${({ $isDragging }) => ($isDragging ? 'pointer-events: none' : '')};
  }
`;
